import { Box, IconButton, Avatar } from "@mui/material";
import { stringAvatar } from "../../utils/avatar";
import { Dispatch, SetStateAction, useEffect } from "react";
import imageCompression from "browser-image-compression";
import alertService from "../alert/alertService";

interface Props {
  avatar: string | undefined;
  displayName: string;
  setAvatarChange: Dispatch<SetStateAction<string | undefined>>;
  hidden?: boolean;
}

export const AvatarWithUpload = ({
  avatar,
  displayName,
  setAvatarChange,
  hidden = false,
}: Props) => {
  const compressImageAccurately = async (file: File) => {
    let quality = 1;
    let compressedFile = file;

    while (quality > 0.1) {
      compressedFile = await imageCompression(file, {
        maxWidthOrHeight: 600,
        initialQuality: quality,
        fileType: "image/webp",
        useWebWorker: true,
      });
      if (compressedFile.size <= 100 * 1024) break;
      quality -= 0.1;
    }

    return compressedFile;
  };

  const handleImageChange = async (
    event: React.ChangeEvent<HTMLInputElement>
  ) => {
    const file = event.target.files?.[0];

    if (file) {
      try {
        const compressedFile = await compressImageAccurately(file);

        const imageDataUrl = await imageCompression.getDataUrlFromFile(
          compressedFile
        );
        setAvatarChange(imageDataUrl.split(",")[1]);
      } catch (e) {
        alertService.error("Failed to resize image");
      }
    }
  };

  return (
    <Box>
      <IconButton
        component="label"
        sx={{
          padding: "0",
        }}
      >
        {!hidden && (
          <>
            {" "}
            <Box
              height={"40px"}
              width={"40px"}
              bgcolor={"var(--green)"}
              style={{
                zIndex: 1,
                position: "absolute",
                pointerEvents: "none",
                bottom: 0,
                right: 0,
                borderRadius: "50%",
              }}
            >
              <img
                src="/img/edit-white.svg"
                alt="edit-icon"
                height={"24px"}
                width={"24px"}
                style={{
                  color: "white",
                  position: "absolute",
                  top: "50%",
                  left: "50%",
                  transform: "translate(-50%, -50%)",
                }}
              />
            </Box>
            <input
              type="file"
              accept="image/*"
              onChange={handleImageChange}
              hidden
            />
          </>
        )}

        <Avatar
          src={avatar ? `data:image/png;base64,${avatar}` : ""}
          {...stringAvatar(displayName)}
          sx={{
            fontSize: "56px",
            width: "112px",
            height: "112px",
            zIndex: 0,
          }}
        />
      </IconButton>
    </Box>
  );
};
